<template>
  <v-container fluid grid-list-lg>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    ></Create>

    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editClassRoom="selectedClassRoom"
    >
    </Edit>

    <AssignStudent
      :editDialog="assignStudentDialog"
      @close="assignStudentClose"
      @submit="assigntStudentSubmit"
      :selectedClassRoom="selectedClassRoom"
    ></AssignStudent>

    <AssignCurriculum
      :editDialog="assignCurriculumDialog"
      @close="assignCurriculumClose"
      @submit="assigntCurriculumSubmit"
      :selectedClassRoom="selectedClassRoom"
    ></AssignCurriculum>

    <AssignTeacher
      :editDialog="assignTeacherDialog"
      @close="assignClose"
      @submit="getList"
      :selectedClassRoom="selectedClassRoom"
    ></AssignTeacher>

    <v-card :loading="loading" outlined>
      <ListTitle
        :showBackButton="!ClassId"
        :access="!ClassId && checkRightStatus(29)"
        title="Class Room"
        @add="add"
      />

      <v-card-title>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search"
              outlined
              prepend-inner-icon="search"
              rounded
              dense
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4">
            <ClassesDropbox @classSelected="classSelected" />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :loading="loading"
        :sort-by="sortBy"
        :expanded.sync="expanded"
        show-expand
        hide-default-footer
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item, isExpanded, expand }">
          <tr class="pointer">
            <td class="text-left">
              <v-btn @click="expand(true)" icon v-if="!isExpanded">
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
              <v-btn @click="expand(false)" icon v-if="isExpanded">
                <v-icon>mdi-chevron-up</v-icon>
              </v-btn>
            </td>
            <td class="text-left">{{ item.name }}</td>
            <td class="text-left">
              <div v-if="item.Class">{{ item.Class.name }}</div>
              <div v-else>N/A</div>
            </td>
            <td class="text-left">{{ item.studentCount }}</td>
            <td class="text-left">
              <div v-for="teacher in item.ClassRoomTeachers" :key="teacher.id">
                <div v-if="teacher && teacher.Teacher">
                  {{ teacher.Teacher.name }}
                </div>
              </div>
            </td>
            <td class="text-left">
              <div v-if="item.Curriculum">
                {{ item.Curriculum.name }}
              </div>
              <div v-else>
                <v-chip
                  small
                  color="pink"
                  text-color="white"
                  class="font-weight-bold"
                  label
                >
                  No Curriculum Assigned
                </v-chip>
              </div>
            </td>

            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item @click="createClassRoomReportCard(item)">
                    <v-list-item-title>Create Report Card</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item @click="assignStudentOpen(item)">
                    <v-list-item-title>Assign Student</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="assignTeacherOpen(item)">
                    <v-list-item-title>Assign Teacher</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="!item.CurriculumId"
                    @click="assignCurriculumOpen(item)"
                  >
                    <v-list-item-title>Assign Curriculum</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-else @click="removeCurriculum(item)">
                    <v-list-item-title>Remove Curriculum</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="checkRightStatus(31)"
                    @click="editClass(item)"
                  >
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    v-if="checkRightStatus(32)"
                    @click="deleteClass(item)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-0">
            <v-card color="#F3F8FC" text class="elevation-0">
              <ClassRoomStudentList
                :ClassRoomId="item.id"
                @getList="getList()"
              />
            </v-card>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
    <ClassroomReportCard
      v-if="classroomReportDialog"
      :ClassRoom="classroomForReport"
      @close="classroomReportDialog = false"
    />
  </v-container>
</template>

<script>
import classRoomService from "@/modules/ClassRoom/service.js";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
const AssignStudent = () =>
  import("@/modules/ClassRoom/components/AssignStudent.vue");
const AssignCurriculum = () =>
  import("@/modules/ClassRoom/components/AssignCurriculum.vue");
const AssignTeacher = () =>
  import("@/modules/ClassRoom/components/AssignTeacher.vue");
const ClassroomReportCard = () =>
  import("@/modules/ClassRoom/components/ClassroomReportCard.vue");
const ClassRoomStudentList = () =>
  import("@/modules/Student/components/ClassRoomStudentList");
const ClassesDropbox = () => import("@/modules/Classes/components/Dropbox.vue");

export default {
  name: "class-list",
  props: ["ClassId"],
  data() {
    return {
      classroomReportDialog: false,
      classroomForReport: null,
      expanded: [],
      singleExpand: false,
      selectedClassRoom: null,
      createDialog: false,
      assignStudentDialog: false,
      assignCurriculumDialog: false,
      assignTeacherDialog: false,
      selectedTeacher: null,
      selectedStudent: null,
      editDialog: false,
      selectedClass: null,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Class",
          align: "left",
          value: "Class.name",
          sortable: true,
        },
        {
          text: "Student Count",
          align: "left",
          value: "studentCount",
          sortable: true,
        },
        {
          text: "Assign Teacher",
          align: "left",
          value: "teacherCount",
          sortable: true,
        },
        {
          text: "Curriculum",
          align: "left",
          value: "Curriculum.name",
          sortable: true,
        },
        {
          text: "",
          width: "20px",
          value: "action",
          sortable: false,
        },
      ],
      items: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "balance",
      pageCount: 0,
      itemsPerPage: 10,
      selectedClasses: [],
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Class Room List";
  },
  components: {
    Create,
    ClassRoomStudentList,
    Edit,
    AssignStudent,
    AssignTeacher,
    ClassroomReportCard,
    AssignCurriculum,
    ClassesDropbox,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    assignTeacherOpen(val) {
      this.selectedClassRoom = val;
      this.assignTeacherDialog = !this.assignTeacherDialog;
    },
    assigntStudentSubmit() {
      this.assignStudentDialog = !this.assignStudentDialog;
      this.getList();
    },
    assigntCurriculumSubmit() {
      this.assignCurriculumDialog = !this.assignCurriculumDialog;
      this.getList();
    },
    assignCurriculumOpen(val) {
      this.selectedClassRoom = val;
      this.assignCurriculumDialog = !this.assignCurriculumDialog;
    },
    assignCurriculumClose() {
      this.selectedClassRoom = null;
      this.assignCurriculumDialog = !this.assignCurriculumDialog;
    },
    removeCurriculum(row) {
      this.$swal({
        title: "Are you sure?",
        text: "You want to remove remove this curriculum from class",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          return classRoomService
            .update(row.id, {
              CurriculumId: null,
            })
            .then((response) => {
              if (response.data) {
                this.$swal(
                  "Removed!",
                  "Curriculum Removed Successfully.",
                  "success"
                );
                this.getList();
              }
            });
        }
      });
    },
    assignStudentOpen(val) {
      this.selectedClassRoom = val;
      this.assignStudentDialog = !this.assignStudentDialog;
    },
    createClassRoomReportCard(classRoom) {
      if (!classRoom.CurriculumId) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "No curriculum assigned to this classroom",
          });
        return;
      }

      if (!classRoom.studentCount) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "No students found in this classroom",
          });
        return;
      }

      this.classroomForReport = classRoom;
      this.classroomReportDialog = true;
    },
    assignStudentClose() {
      this.selectedStudent = null;
      this.assignStudentDialog = !this.assignStudentDialog;
    },
    assignClose() {
      this.assignTeacherDialog = !this.assignTeacherDialog;
      this.getList();
    },
    add() {
      this.createDialog = !this.createDialog;
    },
    classSelected(val) {
      this.selectedClasses = val;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.editDialog = false;
      this.createDialog = false;

      let where = {};

      if (this.ClassId) where = { ClassId: this.ClassId };
      where.filteredClasses = this.selectedClasses;

      return classRoomService.getAll(where).then((response) => {
        this.loading = false;

        this.items = response.data.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase();
          const nameB = (b.name || "").toLowerCase();
          return nameA.localeCompare(nameB);
        });

        this.itemsPerPage = this.items.length;
        return response;
      });
    },
    editClass(val) {
      this.selectedClassRoom = val;
      this.editDialog = !this.editDialog;
    },
    deleteClass(row) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          classRoomService.delete(row.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Classroom has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
